import { render } from "./setting-page.vue?vue&type=template&id=2a3e7d73&scoped=true"
import script from "./setting-page.vue?vue&type=script&lang=js"
export * from "./setting-page.vue?vue&type=script&lang=js"

import "./setting-page.vue?vue&type=style&index=0&id=2a3e7d73&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3e7d73"]])

export default __exports__